module.exports = __webpack_public_path__ + "assets/acd79d241d235cd1ce2723dcc65dba92.png";